// components/ui/AppFooter.tsx
const currentYear = new Date().getFullYear()

export const AppFooter = () => {
  return (
    <footer className="mt-auto pt-4 px-4 sm:px-5 md:px-6 text-center bg-background/30">
      {/* Made with love */}
      {/* <p className="text-[13px] text-gray-950 dark:text-white" style={{ fontSize: '13px' }}>
        Made with 🩷 for the ND community, by the ND community.
      </p> */}
      <div className="pt-2">
        {/* Copyright - increased spacing */}
        <p className="text-[13px] text-foreground" style={{ fontSize: '13px' }}>
          {currentYear} UniquelyND. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
